import TableRow from '@tiptap/extension-table-row';

export const TableRowNode = TableRow.extend({
  name: 'table_row',

  content: '(table_cell | table_header)*',
});
